import { Form, Input, message, Modal, notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useState } from 'react'
import { generateMessageError } from 'modules/core/utils'
import societies from 'modules/societies'

const AssignEmailModal = ({ visible, onClose, onRefetch, userId, assignEmail }) => {
  const [isSaving, setIsSaving] = useState(false)
  const [form] = Form.useForm()
  const { t } = useTranslation()

  const onCancel = () => {
    form.resetFields()
    onClose()
  }

  const onConfirm = () => {
    form.validateFields().then((values) => {
      setIsSaving(true)
      assignEmail(userId, values)
        .then(() => {
          onRefetch().then(() => {
            message.success(t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
            setIsSaving(false)
            onCancel()
          })
        })
        .catch((error) => {
          setIsSaving(false)
          onCancel()
          notification.error({
            message: t('FEEDBACK_DEFAULT_ERROR'),
            description: generateMessageError(error),
            duration: 0,
          })
        })
    })
  }

  return (
    <Modal
      title={t('SOCIETY_ASSIGN_EMAIL_MODAL_TITLE')}
      visible={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText={t('ACTION_SAVE')}
      okButtonProps={{ loading: isSaving }}
      cancelButtonProps={{ disabled: isSaving }}
      centered
      destroyOnClose
      forceRender
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="email2"
          label={t('FIELD_EMAIL')}
          rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
        >
          <Input placeholder={t('ACTION_ENTER')} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

const mapDispatchToProps = {
  assignEmail: societies.actions.assignEmail,
}

export default connect(null, mapDispatchToProps)(AssignEmailModal)
